import { Validators } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { AuthService } from './../../../services/user/auth.service';
import { SelectItem } from 'primeng/primeng';
import { RolesManagementService } from './../../../services/roles-management/roles-management.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-roles-management',
  templateUrl: './roles-management.component.html',
  styleUrls: ['./roles-management.component.css']
})
export class RolesManagementComponent implements OnInit {
  companyId: number;
  applications: any[] = [];
  selectedApplications: string[];
  roles: SelectItem[];
  selectedRole: string;
  showLoadProfileDialog = false;
  showSaveProfileDialog = false;
  profiles: SelectItem[];
  selectedProfileId: number;
  permissions: any[] = [];
  permissionsToShow: any[] = [];
  noFilter = KontableComponent.NoFilter;
  saveProfileForm: FormGroup;
  invalidSubmit: boolean;

  constructor(
    private authService: AuthService,
    private rolesManagementService: RolesManagementService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.companyId = this.authService.user.selectedCompany;
    this.getApplications();
    this.getRoles();
    this.getProfiles();
    this.saveProfileForm = this.fb.group({
      name: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  getApplications() {
    this.rolesManagementService.getCompanyApplications(this.companyId).subscribe(res => this.applications = res);
  }

  getRoles() {
    this.roles = [{label: '', value: null}];
    this.rolesManagementService.getCommonRoles().subscribe(res => res.forEach(role => {
      this.roles.push({label: role.description, value: role.description});
    }));
  }

  getProfiles() {
    this.profiles = [{label: '', value: null}];
    this.rolesManagementService.getProfiles().subscribe(res => {
      res.forEach(profile => this.profiles.push({label: profile.name, value: profile.id}));
      this.showLoadProfileDialog = true;
    });
  }

  loadProfile() {
    this.rolesManagementService.loadProfile(this.selectedProfileId, this.selectedRole).subscribe(res => {
      this.filterPermissions(res);
      this.showLoadProfileDialog = false;
    });
  }

  filterPermissions(permissions: any[]) {
    this.permissions = permissions;
    if (this.selectedApplications && this.selectedApplications.length > 0) {
      this.permissionsToShow = permissions.filter(app => this.selectedApplications.indexOf(app.application_id.toString()) !== -1);
    } else {
      this.permissionsToShow = permissions;
    }
  }

  showPermissions() {
    this.rolesManagementService.showPermission(this.selectedRole).subscribe(res => {
      this.selectedProfileId = null;
      this.filterPermissions(res);
    })
  }

  saveRole() {
    this.rolesManagementService.saveRole(this.permissionsToShow).subscribe();
  }

  resetPermissions() {
    this.selectedProfileId ? this.loadProfile() : this.showPermissions();
  }

  saveProfile() {
    if (!this.saveProfileForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;
    const data = {
      name: this.saveProfileForm.get('name').value,
      description: this.saveProfileForm.get('description').value,
      jpermission: {
        jpermission: this.permissionsToShow
      }
    }
    this.rolesManagementService.saveProfile(data).subscribe(() => {
      this.showSaveProfileDialog = false;
      this.getProfiles();
    });
  }

  permissionRow(event) {
    console.log(event);
    if (event.associated) {
      event.allowsGET = true;
      event.allowsPUT = true;
      event.allowsPOST = true;
      event.allowsDELETE = true;
    } else {
      event.allowsGET = false;
      event.allowsPUT = false;
      event.allowsPOST = false;
      event.allowsDELETE = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/roles-management/roles-management.component.ts